import * as yup from 'yup';

export const strongPasswordValidation = yup.object().shape({
  password: yup
    .string()
    .test(
      'dontHaveSpecialCharacters',
      'Inclua caracteres especiais na sua nova senha',
      value => !!value?.match('[^A-Za-z0-9]')
    )
    .test(
      'dontHaveUppercaseLetters',
      'Inclua letras maiúsculas na sua nova senha',
      value => !!value?.match('[A-Z]')
    )
    .test(
      'dontHaveLowerLetters',
      'Inclua letras minúsculas na sua nova senha',
      value => !!value?.match('[a-z]')
    )
    .test(
      'dontHaveNumbers',
      'Inclua números na sua nova senha',
      value => !!value?.match('[0-9]')
    )
    .min(8, 'A nova senha deve possuir no mínimo 8 caracteres')
    .required('Digite uma senha'),
});
